import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
  title: { color: theme.palette.tab.offselected },
  subtitle: {
    color: theme.palette.primary.main,
    fontWeight: 500,
  }
}));
